import { render, staticRenderFns } from "./Farmaciahistorial.vue?vue&type=template&id=22d33fec&"
import script from "./Farmaciahistorial.vue?vue&type=script&lang=js&"
export * from "./Farmaciahistorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports